import React, { Suspense, useEffect, useState } from "react";
import { Provider } from "react-redux";
import AppStore from "../requests/redux/store";
import { ATSWrapper, Kanban, GoogleWrapper } from "@rankmi/ats-app";
import "antd/dist/antd.css";
import "@rankmi/rankmi-styles/dist/css/reset-ant/main.css";
import "@rankmi/rankmi-components/dist/index.css";
import "@rankmi/ats-app/dist/index.css";
import { getTimeFrom } from "@frontend/helpers/formatDate";
import moment from 'moment';


/**
 * Read-only wrapper for the ats-app Kanban.
 * - Forces mode="viewOnly"
 * - Disables add/move/delete actions at card/column/process level
 * - Preserves filters, search and sorting
 */
const ATSKanbanReadOnly = ({
  selectionProcess: {
    id = 0,
    title = "",
    assessmentId = null,
    statusColor
  },
  googleClientId,
  creator,
  createdAt,
}) => {
  const processInfo = {
    name: title,
    stateColor: statusColor,
    assessmentId,
    tags: [
      { label: `ID: ${id}`, icon: "fingerprint" },
      { label: creator, icon: "user" },
      { label: getTimeFrom(moment(createdAt).locale('es')), icon: "calendar", tooltip: { title: moment(createdAt).format("DD/MM/YYYY")} },
    ]
  };

  const [kanbanSize, setKanbanSize] = useState('M');

  useEffect(() => {
    const savedSize = sessionStorage.getItem('ats_kanban_size');
    if (savedSize) setKanbanSize(savedSize);
  }, []);

  return (
    <div style={{ width: "97%" }} data-testid="ATSKanbanReadOnly">
      <Suspense fallback={""}>
        <GoogleWrapper clientId={googleClientId}>
          <ATSWrapper>
            <Provider store={AppStore}>
              <Kanban
                canEditTags={false}
                activeAddButton={false}
                processId={id}
                processInfo={processInfo}
                mode="viewOnly"
                kanbanSize={kanbanSize}
                onKanbanSizeChange={(size) => {
                  setKanbanSize(size);
                  sessionStorage.setItem('ats_kanban_size', size);
                }}
                // El wrapper de solo lectura no consume los totales. Mantener un
                // callback seguro evita que el evento interno del Kanban falle por
                // referenciar un setter que no existe en este componente.
                handleApplicantsTotal={() => {}}
                onCardClick={() => {}}
              />
            </Provider>
          </ATSWrapper>
        </GoogleWrapper>
      </Suspense>
    </div>
  );
};

export default ATSKanbanReadOnly;

